export const PDF_DOWNLOAD_COOLDOWN_STORAGE_KEY =
  "pdf-download-cooldown-until";
export const PDF_DOWNLOAD_COOLDOWN_MS = 10_000;
export const PDF_DOWNLOAD_COOLDOWN_SECONDS = PDF_DOWNLOAD_COOLDOWN_MS / 1_000;

function readCooldownUntilMs(): number | null {
  try {
    const raw = window.sessionStorage.getItem(
      PDF_DOWNLOAD_COOLDOWN_STORAGE_KEY,
    );

    if (!raw) {
      return null;
    }

    const until = Number(raw);

    if (!Number.isFinite(until)) {
      window.sessionStorage.removeItem(PDF_DOWNLOAD_COOLDOWN_STORAGE_KEY);
      return null;
    }

    return until;
  } catch {
    return null;
  }
}

export function readCooldownRemainingSeconds(now = Date.now()): number | null {
  const until = readCooldownUntilMs();

  if (until === null) {
    return null;
  }

  const remainingSeconds = Math.ceil((until - now) / 1_000);

  if (remainingSeconds <= 0) {
    clearDownloadCooldown();
    return null;
  }

  return remainingSeconds;
}

export function writeCooldownUntil(epochMs: number) {
  try {
    window.sessionStorage.setItem(
      PDF_DOWNLOAD_COOLDOWN_STORAGE_KEY,
      String(epochMs),
    );
  } catch {
    // sessionStorage may be unavailable (private mode / quota); UI still works.
  }
}

export function clearDownloadCooldown() {
  try {
    window.sessionStorage.removeItem(PDF_DOWNLOAD_COOLDOWN_STORAGE_KEY);
  } catch {
    // Ignore storage failures when clearing.
  }
}

export function startDownloadCooldown(
  durationSeconds: number,
  now = Date.now(),
) {
  const seconds = Math.max(1, Math.ceil(durationSeconds));
  writeCooldownUntil(now + seconds * 1_000);
  return seconds;
}
